var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 136,
    r: 15,
    fill: "#ffffff",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 136,
    r: 15,
    fill: "#ffffff",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 136,
    r: 15,
    fill: "#ffffff",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.213 481c24.695 0 44.787-20.187 44.787-45v-60c0-6.453-4.127-12.182-10.246-14.227l-89.787-30c-4.396-1.468-9.219-.823-13.074 1.746l-38.183 25.455c-40.978-19.444-89.411-67.448-108.675-107.698l25.446-38.169c2.569-3.854 3.214-8.68 1.746-13.074l-30-89.787c-2.045-6.12-7.774-10.246-14.227-10.246h-60c-24.813 0-45 20.091-45 44.787 0 82.877 37.684 167.936 103.39 233.367 65.634 65.36 150.86 102.846 233.823 102.846zm-292.213-351h49.197l24.25 72.576-25.927 38.89c-2.74 4.11-3.281 9.305-1.446 13.891 9.975 24.937 29.937 52.984 56.208 78.975 26.098 25.819 54.282 45.563 79.361 55.594 4.585 1.834 9.782 1.293 13.891-1.446l38.891-25.927 72.575 24.25v49.197c0 8.411-6.495 15-14.787 15-157.913 0-307.213-148.814-307.213-306.213 0-8.292 6.589-14.787 15-14.787z",
    fill: "#ffffff",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.26 299.858c5.604 2.322 12.057 1.038 16.347-3.251l55.606-55.607h53.787c58.448 0 106-47.103 106-105s-47.552-105-106-105h-120c-57.897 0-105 47.103-105 105 0 52.805 39.183 96.631 90 103.932v46.068c0 6.067 3.655 11.536 9.26 13.858zm-69.26-163.858c0-41.355 33.645-75 75-75h120c41.906 0 76 33.645 76 75s-34.094 75-76 75h-60c-3.979 0-7.794 1.58-10.606 4.393l-34.394 34.394v-23.787c0-8.284-6.716-15-15-15-41.355 0-75-33.645-75-75z",
    fill: "#ffffff",
    "data-original": "#000000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2939bccf52b8313b8218be299060efb3.svg";
export { ForwardRef as ReactComponent };